import { AllStoresStockStatus, WarehouseStockStatus } from '../types/StockStatus';
import { ProductDeliveryAllStoresValue, ProductDeliveryWarehouseValue } from './ProductDeliveryInfoValue';

export const DEFAULT_WAREHOUSE: ProductDeliveryWarehouseValue = {
    stockStatus: WarehouseStockStatus.Unavailable,
};

export const DEFAULT_STORE: ProductDeliveryAllStoresValue = {
    stockStatus: AllStoresStockStatus.Unavailable,
    clickAndCollectTitle: '',
};
